const API_BASE_URL =
    process.env.REACT_APP_GENESIS_API_URL ||
    "https://genesis-api-prod-bzfxa2a0aybugqhp.westus2-01.azurewebsites.net";

export async function fetchBlogs({
    pageNumber = 1,
    pageSize = 50,
    filter = {},
    signal,
} = {}) {
    const response = await fetch(`${API_BASE_URL}/api/Blog/get_blogs`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            pageNumber,
            pageSize,
            filter,
        }),
        signal,
    });

    if (!response.ok) {
        throw new Error("Unable to load blogs right now.");
    }

    const payload = await response.json();

    if (payload.status_code !== 200) {
        throw new Error(payload.message || "Unable to load blogs right now.");
    }

    let items = [];
    let totalRecords = 0;
    let totalPages = 1;

    if (Array.isArray(payload.data)) {
        items = payload.data;
        totalRecords = payload.totalRecords ?? items.length;
        totalPages = payload.totalPages ?? 1;
    } else if (payload.data && Array.isArray(payload.data.items)) {
        items = payload.data.items;
        totalRecords =
            payload.data.totalRecords ??
            payload.data.totalCount ??
            items.length;
        totalPages = payload.data.totalPages ?? 1;
    } else if (Array.isArray(payload.items)) {
        items = payload.items;
        totalRecords = payload.totalRecords ?? items.length;
        totalPages = payload.totalPages ?? 1;
    }

    return {
        items,
        totalRecords,
        totalPages,
    };
}
